import { Meta, Title } from '@angular/platform-browser';
import { Component, OnInit, HostListener, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DestroySubscribers } from 'src/app/theme/utils/util-functions';
import { of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
@DestroySubscribers()
export class CategoriesComponent implements OnInit, OnChanges {
  @Input() categories;
  private _categories: any[] = [];
  filteredCategories: any[] = [];
  private destroy$ = new Subject<void>();

  @Input()
  set filterCategoriesMenu(value: any[]) {
    if (value) {
      this._categories = value.filter(
        category => category.category_name !== 'Previously Ordered'
      );
      this.filteredCategories = this._categories;
    }
  }
  get filterCategoriesMenu(): any[] {
    return this._categories;
  }

  categoriesArray = [];
  public viewType: string = 'grid';
  public viewCol: number = 25;
  private storeDetails = {};
  storeDetailsJson = {};
  mouseOverIndex = -1;
  categoryImageUrl;
  array = [1, 2, 3, 4, 5];
  url = this.router.url.split('?')[0];
  featureTags = {};

  constructor(
    private apiService: ApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['categories']) {
      // console.log('Categories changed:', changes['categories'].currentValue);
    }
  }

  ngOnInit() {
    this.storeDetails = this.activatedRoute.snapshot.data['store']['response']['data']['store'];
    this.storeDetailsJson = this.activatedRoute['snapshot']['data']['store']['response']['data']['store_json'];
    // this.getCategories();
    this.categoryImageUrl = environment.categoryImageUrl + this.storeDetails['id'] + "/";
    if (window.innerWidth < 1280) {
      this.viewCol = 25;
    };
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
  }
  getCategories() {
    this.apiService.categories()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result['response']['status'] === 1) {        
        this.categories = result['response']['data']['cat_list'];
      }
    }, (error) => {
      if (error) {
        console.log(error);
      }
      return of(null); // In SSR, Prevent memory leaks by returning a safe value
    });
  }
  @HostListener('window:resize')
  public onWindowResize(): void {
    (window.innerWidth < 1280) ? this.viewCol = 25 : this.viewCol = 25;
  }
  onMouseOver(index) {
    this.mouseOverIndex = index;
  }
  onMouseOut(e) {
    this.mouseOverIndex = -1;
  }
  imageErrorHandler(event) {
    event.target.src = 'https://1dev-order.homemilkdelivery.com/img/no_image_found.png';
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
